/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SearchPatientDisplacementAliases {
  AUTOCOMPLETE_DEPARTMENTS = 'autocomplete-departments',
  BARCODE_COMPONENT = 'barcode-component',
  CONTEXTUAL_BAR_DISPLACEMENT = 'contextual-bar-displacement',
  CONTEXTUAL_BAR_LAYOUT = 'contextual-bar-layout',
  FETCH_DEPARTMENTS = 'fetch-departments',
  FIELD_DEPARTMENTS = 'field-departments',
  FILTER_FIELD_ENCOUNTER = 'filter-field-encounter',
  FILTER_PATIENTS = 'filter-patients',
  FILTERED_LIST = 'filtered-list',
  FILTERED_LIST_PANEL = 'filtered-list-panel',
  LAYOUT_LOADER = 'layout-loader',
  LAYOUT_SEARCH_PATIENT_DISPLAY = 'layout-search-patient-display',
  LOADER = 'loader',
  MAPPER_DEPARTMENTS = 'mapper-departments',
  MODAL = 'modal',
  PANEL_LOADER = 'panel-loader',
  PANEL_MODAL = 'panel-modal',
  PATIENT_FETCH = 'patient-fetch',
  PATIENT_FETCH_AVATAR = 'patient-fetch-avatar',
  PATIENT_FETCH_CARD = 'patient-fetch-card',
  PATIENT_FETCH_DECK = 'patient-fetch-deck',
  PATIENT_FETCH_MAPPER = 'patient-fetch-mapper',
  PATIENT_FETCH_MAPPER_DECK = 'patient-fetch-mapper-deck',
  PATIENT_FETCH_PANEL = 'patient-fetch-panel',
  TEXT_DEPARTMENTS = 'text-departments',
}
export { SearchPatientDisplacementAliases };
